module.exports = __WEBPACK_EXTERNAL_MODULE__icon__;